import {Layout, Anchor, Typography} from 'antd';
import React, {useState} from 'react';
import appColors from '../../style/theme';
import DAptamersLogic from './DAptamers';
import DEDesignLogic from './DEDesign';
import DManualLogic from './DManual';
import DOvLogic from './DOv';
const {Link} = Anchor;
const {Sider, Content} = Layout;
const Text = Typography;


const handleClick = (e, link) => {
  e.preventDefault();
  console.log(link);
};

const DescriptionLogic = () => {
  const [backI, setBackI] = useState('transparent');
  const [backII, setBackII] = useState('transparent');
  const [backIII, setBackIII] = useState('transparent');
  const [backIV, setBackIV] = useState('transparent');
  const ChangeAnchor = (key) => {
    console.log(key);
    if (key === '#DOv') {
      setBackI(appColors['ColorB']);
      setBackII('transparent');
      setBackIII('transparent');
      setBackIV('transparent');
    } else if (key === '#Dapt') {
      setBackI('transparent');
      setBackII(appColors['ColorB']);
      setBackIII('transparent');
      setBackIV('transparent');
    } else if (key === '#DED') {
      setBackI('transparent');
      setBackII('transparent');
      setBackIII(appColors['ColorB']);
      setBackIV('transparent');
    } else if (key === '#DMan') {
      setBackI('transparent');
      setBackII('transparent');
      setBackIII('transparent');
      setBackIV(appColors['ColorB']);
    }
  };
  return (
    <Layout style={{background: 'transparent'}}>
      <Sider style={{background: 'transparent'}}>
        <Anchor onClick={handleClick} offsetTop={75} onChange={ChangeAnchor} style={{background: 'transparent'}}>
          <Link href='#DOv' title={<Content className='ContentAnchor' style={{borderColor: backI}}><Text style={{color: appColors['ColorB'], fontSize: '2vh'}}>C-Reactive Protein</Text></Content>}/>
          <Link href='#Dapt' title={<Content className='ContentAnchor' style={{borderColor: backII}}><Text style={{color: appColors['ColorB'], fontSize: '3vh'}}>Aptamers</Text></Content>}/>
          <Link href='#DED' title={<Content className='ContentAnchor' style={{borderColor: backIII}}><Text style={{color: appColors['ColorB'], fontSize: '3vh'}}>Workflow</Text></Content>}/>
          <Link href='#DMan' title={<Content className='ContentAnchor' style={{borderColor: backIV}}><Text style={{color: appColors['ColorB'], fontSize: '3vh'}}>References</Text></Content>}/>
        </Anchor>
        <p style={{color: appColors['ColorB'], pointerEvents: 'none', fontSize: '2vh', top: '65vh', left: '5vh', textAlign: 'center', position: 'sticky'}}> D&nbsp;<br/> E&nbsp;<br/> S&nbsp;<br/> C&nbsp;<br/> R&nbsp;<br/> I&nbsp;<br/> P&nbsp;<br/> T&nbsp;<br/> I&nbsp;<br/> O&nbsp;<br/> N&nbsp;</p>
      </Sider>
      <Layout style={{margin: '1% 1% 0 1%', width: 'fit-content'}}>
        <Layout style={{background: appColors['Colorx'], height: '1px'}} />
        <Layout className='PurpBack' style={{background: appColors['ColorG']}}>
          <Layout style={{margin: '0 0 0 0', background: 'transparent'}}>
            <div id='DOv'>
              <DOvLogic/>
            </div>
            <div id='Dapt'>
              <DAptamersLogic/>
            </div>
            <div id='DED'>
              <DEDesignLogic/>
            </div>
            <div id='DMan'>
              <DManualLogic/>
            </div>
          </Layout>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default DescriptionLogic;
